/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Asc/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import Tysiav2FilterAsc from 'DesignSystem/Svgs/Tysiav2FilterAsc/index'



/** @type {import('Simple/types.js').View} */
export default function Asc({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/StageHeader/Sort/Content/SortItem/Asc"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let sortSelectedValueData = fromData.useDataValue({ viewPath,
context: 'sort',
path: 'selected',
})
let sortFilterIdValueData = fromData.useDataValue({ viewPath,
context: 'sort_filter',
path: 'id',
})
let aggregateData = fromHelpers.isSelected(sortSelectedValueData, sortFilterIdValueData)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let sortFilterIdValueData1 = fromData.useDataFormat({ viewPath,
context: 'sort_filter',
path: 'id',
format: fromHelpers.getText,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="right"
 offsetMainAxis={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 paddingLeft={0}
 paddingRight={0}
 paddingTop={0}
 paddingBottom={0}
 type="ghost"
 cursor="pointer"
 onClick={onClick}
>
{childProps => (
<Tysiav2FilterAsc
{...childProps}
  viewPath={`${viewPath}/Tysiav2FilterAsc`}
 fill2={aggregateData ? dtColorsGreen700 : dtColorsNeutral400}
 data="sort.selected"
 data="sort_filter.id"
 aggregate="helpers.js isSelected"
/>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 maxWidth="fit-content"
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral500}
 height="auto"
 className="new-shadow"
 whiteSpace="normal"
 data="sort_filter.id"
 format="helpers.js getText"
 text={sortFilterIdValueData1}
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}